var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMastercard = function SvgMastercard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 116.49 72",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M42.5 7.7H74v56.61H42.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb001b",
    d: "M44.5 36A35.92 35.92 0 0 1 58.25 7.7a36 36 0 1 0-.01 56.6A35.94 35.94 0 0 1 44.49 36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f79e1b",
    d: "M116.49 36a36 36 0 0 1-58.25 28.3 36.01 36.01 0 0 0 0-56.61A35.99 35.99 0 0 1 116.49 36m-3.43 22.31v-1.16h.47v-.24h-1.19v.24h.47v1.16h.26Zm2.31 0v-1.4h-.36l-.42.96-.42-.96h-.36v1.4h.26v-1.05l.39.91h.27l.39-.91v1.06h.26Z"
  })));
};
export { SvgMastercard as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.b69a8824100bc728f952c7c674538597.svg";